import {OperatorItem} from '../../types/models'

const AGENT_EMPLOYEE_OPERATORS = ['inArray', 'notInArray']

export const isAgentEmployeeFilter = (isAgent: boolean, column: string) => isAgent && column === 'to_'

export const agentEmployeeOperators = (operators: OperatorItem[]) =>
  operators.filter((o) => AGENT_EMPLOYEE_OPERATORS.includes(o.value))

export const sanitizeAgentEmployeeRule = <T extends {operator: string; value: unknown}>(
  rule: T,
  allowedValues: string[]
): T => {
  const values = Array.isArray(rule.value) ? rule.value : []
  return {
    ...rule,
    operator: AGENT_EMPLOYEE_OPERATORS.includes(rule.operator) ? rule.operator : 'inArray',
    value: values.filter((v) => allowedValues.includes(v)),
  }
}
